import { useContext } from 'react'

import { AuthContext } from 'features/auth/auth-context'

const INTERNAL_EMAIL_DOMAIN = '@meetyogi.com'

/**
 * Whether the signed-in user is Yogi-internal (staff). Mirrors the
 * backend's `@meetyogi.com` email gate so internal-only surfaces can
 * decide up front instead of waiting for a 403. Lives in the shared
 * layer because identity spans features (same shape as `useCanAccess`).
 * Fail-closed: no email (auth not hydrated, or signed out) reads as
 * not-internal.
 */
export const useIsInternalUser = (): boolean => {
  const { user, userDetails } = useContext(AuthContext)
  const email = user?.attributes?.email ?? userDetails?.email
  return email?.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN) ?? false
}
